import React, {useState} from 'react'
import {
  CToast,
  CToastBody,
  CToastHeader,
  CToaster,
  CRow,
  CCol,  
} from '@coreui/react'
import {setOnNotification} from '../../Manager'
import CIcon from '@coreui/icons-react'

const VMToaster = (props) => {    

  const [toasts, setToasts] = useState([])
  let i=0;

  const addToast = (notification) => {    
    setToasts([
      ...toasts, 
      notification
    ])
  } 

  setOnNotification(addToast)

  return (        
    <CToaster className='no_print' placement="top-end" >
      { 
        toasts.map((toast) => {
        i=i+1        
        return (                                                                         
          <CToast className='no_print' color={toast.color} key={i} visible={true} autohide={toast.autohide} fade={toast.fade} >
            <CToastHeader closeButton={toast.closeButton}>
              <h2>{toast.title}</h2>
            </CToastHeader>
            <CToastBody>
              <CRow>                
                {toast.bodyIcon?
                  <CCol xs={2}>
                    <CIcon content={toast.bodyIcon} height={30}/>                     
                  </CCol>       
                :<></>}
                  <CCol>
                    {toast.body}
                  </CCol>
              </CRow>
            </CToastBody>
          </CToast>)
          }
        )        
      }
      </CToaster>      
  )
}

export {VMToaster}
